exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.phone-user-option[data-v-0edfba10] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  gap: 8px;\n}\n.opt-mobile[data-v-0edfba10] {\n  font-weight: 500;\n  color: #303133;\n}\n.opt-alias[data-v-0edfba10] {\n  font-size: 12px;\n  color: #909399;\n}\n", ""]);

// exports
